"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handlers = exports.mocks = void 0;
const msw_1 = require("msw");
const post_json_1 = __importDefault(require("./mocks/post.json"));
exports.mocks = post_json_1.default;
exports.handlers = [
    msw_1.rest.post(/\/v1.0\/widgets\/clients\/[0-9]+\/investments\/[0-9]+\/analysis\/performance/, (req, res, ctx) => (res(ctx.status(200), ctx.json(post_json_1.default)))),
];
//# sourceMappingURL=handlers.js.map